export default {
  "b2b.provozni-informace-form.field.image.label": "Obrázek",
  "b2b.provozni-informace-form.field.title.label.cs": "Titulek CS",
  "b2b.provozni-informace-form.field.title.label.en": "Titulek EN",
  "b2b.provozni-informace-form.field.title.placeholder.cs":
    "zadejte titulek informace česky",
  "b2b.provozni-informace-form.field.title.placeholder.en":
    "zadejte titulek informace anglicky",
  "b2b.provozni-informace-form.field.description.label.cs": "Popis CS",
  "b2b.provozni-informace-form.field.description.label.en": "Popis EN",
  "b2b.provozni-informace-form.field.description.placeholder.cs":
    "zadejte popisek k náhledu karty informace česky",
  "b2b.provozni-informace-form.field.description.placeholder.en":
    "zadejte popisek k náhledu karty informace anglicky",
  "b2b.provozni-informace-form.field.content.label.cs": "Obsah CS",
  "b2b.provozni-informace-form.field.content.label.en": "Obsah EN",
  "b2b.provozni-informace-form.field.content.placeholder.cs":
    "zadejte obsah informace česky",
  "b2b.provozni-informace-form.field.content.placeholder.en":
    "zadejte obsah informace anglicky",
  "b2b.provozni-informace-form.field.attachments.label": "Přílohy",
  "b2b.provozni-informace-form.button.submit": "Uložit",
  "b2b.provozni-informace-form.button.delete": "Smazat",
  "b2b.provozni-informace-form.button.cancel": "Zrušit",
  "b2b.provozni-informace-form.dialog.submit": "Uložení provozní informace"
};
